import type React from 'react';
import styles from './Auth.module.scss';
import { useOpenOnBrowser } from '../../hooks/todesktop';
import Header from '../../ui/Header';

const DesktopSignin: React.FC = () => {
  const openOnBrowser = useOpenOnBrowser();

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    openOnBrowser(`${window.location.origin}/desktop-auth`);
  };

  return (
    <section className={styles.section}>
      <Header />
      <div className={styles.auth}>
        <form className={styles.auth__form} onSubmit={onSubmit} method="POST">
          <h1>Log into Fabric</h1>

          <p>Click the button below to log in using your Browser.</p>
          <button type="submit" className={styles.form_button}>
            Log in
          </button>
        </form>
      </div>
    </section>
  );
};

export default DesktopSignin;
